var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0396 2.32295C21.0556 1.96795 22.0316 2.94395 21.6766 3.95995L15.7516 20.89C15.3666 21.988 13.8366 22.05 13.3646 20.987L10.5056 14.555L14.5296 10.53C14.6621 10.3878 14.7342 10.1997 14.7308 10.0054C14.7274 9.81113 14.6486 9.62574 14.5112 9.48833C14.3738 9.35092 14.1884 9.27221 13.9941 9.26878C13.7998 9.26535 13.6118 9.33747 13.4696 9.46995L9.44461 13.494L3.01261 10.635C1.94961 10.162 2.01261 8.63295 3.10961 8.24795L20.0396 2.32295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconButton);
export default __webpack_public_path__ + "static/media/sendIconButton.014dd4da5791cc3e1c5c27bc3ec8d39c.svg";
export { ForwardRef as ReactComponent };